<template>
  <div class="ace-diet-table">
    <div class="ace-diet-table__result">
        <span class="ace-diet-table__result-value"> {{ resultValue }}</span>
        <span class="ace-diet-table__result-unit"> {{ resultUnit }}</span>
        <span class="ace-diet-table__result-title"> {{ resultTitle }}</span>
    </div>
    <h3 class="ace-diet-table__title">{{ dietTitle }}</h3>
    <!-- <span>EDITABLE</span> -->
    <table class="ace-diet-table__table">
      <thead>
        <tr>
          <th>Product</th>
          <th>%DM</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(component, key) in diet" :key="key">
          <td>{{ component.title }}</td>
          <td>{{ percent(component.percentage) }}</td>
          <!-- <td>{{ component.title }}</td> -->
          <!-- <td>{{ percent(component.percentage) }}</td> -->
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { percent } from '../../helpers';

export default {
  data() {
    return {
      exampleDiet: [
        {
          title: 'Barley (Treated)',
          percentage:	17
        },
        {
          title: 'Wheat (Treated)',
          percentage:	34
        },
        {
          title: 'Maize',
          percentage:	11.8

        },
        {
          title: 'Beans Treated',
          percentage:	25

        },
        {
          title: 'Rapeseed Extraction',
          percentage:	8

        },
        {
          title: 'Fat',
          percentage:	1.1

        },
        {
          title: 'Limestone',
          percentage:	1.1

        },
        {
          title: 'Molasses Blend',
          percentage:	0.6

        },
        {
          title: 'Salt',
          percentage:	0.4
        },
        {
          title: 'Lysine',
          percentage:	0.4
        },
        {
          title: 'Special mineral',
          percentage:	0.3

        },
        {
          title: 'MCP',
          percentage:	0.2

        },
        {
          title: 'Methionine',
          percentage:	0.1
        },
        {
          title: 'Threonine',
          percentage:	0.1
        }
      ]
    };
  },
  props: {
    dietTitle: String,
    diet: Array,
    resultValue: Number,
    resultUnit: String,
    resultTitle: String,
    editable: Boolean,
    ingredients: Array,
  },
  methods: {
    percent,
  },
};

</script>

<style scoped lang="scss">
.ace-diet-table
{
    text-align: left;

    width: 100%;

    display: flex;
    flex-direction: column;
    &__result
    {
        display: flex;
        flex-direction: column;

        line-height: 1;

        align-items: center;
        &-value,
        &-unit
        {
            color: #01A34A;

            font-weight: 700;
        }
        &-value
        {
            font-size: 42px;
        }
        &-unit
        {
            margin-top: 10px;

            font-size: 21px;
        }
        &-title
        {
            margin-top: 10px;

            font-size: 14px;
        }
    }
    &__title
    {
        margin-top: 30px;

        font-size: 21px;
        font-weight: 700;
        line-height: 28px;
    }
    &__table
    {
        margin-top: 15px;
        width: 100%;

        font-size: 18px;    th,
        td
        {
            padding: 5px 10px;
        }
        thead
        {
            th
            {
                text-transform: uppercase;

                background: #01A34A;
                border: 1px solid #01A34A;
                color: #FFFFFF;

                font-size: 11px;
                font-weight: 400;
            }
        }
        tbody,
        tfoot
        {
            td
            {
                border: 1px solid #707070;
            }
        }
    }
}

</style>
